class FreeShippingComponent extends HTMLElement {
  constructor() {
    super();
  }

  static freeShippingText = window.free_shipping_text.free_shipping_message;
  static freeShippingText1 = window.free_shipping_text.free_shipping_message_1;
  static freeShippingText2 = window.free_shipping_text.free_shipping_message_2;
  static freeShippingText3 = window.free_shipping_text.free_shipping_message_3;
  static freeShippingText4 = window.free_shipping_text.free_shipping_message_4;
  static classLabel1 = 'progress-30';
  static classLabel2 = 'progress-60';
  static classLabel3 = 'progress-100';

  // Kraj dostawy wg naszego systemu geolokalizacji (naoko-geo-popup):
  // po decyzji klientki (cookie switched/stay) wiążący jest kraj sesji
  // (localization.country ustawiony przez popup/silent-set), wcześniej —
  // kraj wykryty przez Shopify (cache w sessionStorage), na końcu kraj sesji.
  static resolveCountry() {
    const confirmed = /(?:^|;\s*)(naoko_geo_switched|naoko_geo_stay)=/.test(document.cookie);
    if (!confirmed) {
      try {
        const detected = sessionStorage.getItem('naoko_geo_country');
        if (detected) return detected.toUpperCase();
      } catch (e) { /* sessionStorage niedostępny */ }
    }
    return (window.free_shipping_country || '').toUpperCase();
  }

  // Próg z mapy per kraj (metapole shop/naoko.free_shipping_thresholds,
  // sync: scripts/i18n-com/shipping-thresholds-sync.mjs); fallback = legacy
  // setting motywu. hidden=true → kraj bez darmowej dostawy, pasek znika.
  static resolveThreshold() {
    const legacy = {
      amount: parseInt(window.free_shipping_price, 10) || 0,
      currency: window.free_shipping_default_currency,
      hidden: false,
    };
    const map = window.free_shipping_thresholds;
    if (!map || typeof map !== 'object') return legacy;
    const country = FreeShippingComponent.resolveCountry();
    if (Array.isArray(map.no_free) && map.no_free.indexOf(country) !== -1) {
      return { amount: 0, currency: map.currency || legacy.currency, hidden: true };
    }
    let amount = map.countries ? map.countries[country] : null;
    if (amount == null) amount = map.default;
    if (amount == null) return legacy;
    return { amount: parseFloat(amount), currency: map.currency || legacy.currency, hidden: false };
  }

  // Przeliczenie na walutę prezentacji — o ile globalny Currency istnieje
  // (dostarczany poza motywem); bez niego zwracamy kwotę bez przeliczenia.
  static convertToActive(amount, fromCurrency) {
    if (window.Currency && typeof Currency.convert === 'function' && window.Shopify && Shopify.currency) {
      try { return Currency.convert(amount, fromCurrency, Shopify.currency.active); } catch (e) { /* brak kursów */ }
    }
    return amount;
  }

  connectedCallback() {
    this.freeShippingEligible = 0;
    this.progressBar = this.querySelector('[data-shipping-progress]');
    this.messageElement = this.querySelector('[data-shipping-message]');
    this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
    this.shipVal = window.free_shipping_text.free_shipping_1;
    this.progressMeter = this.querySelector('[ data-free-shipping-progress-meter]');

    // this.addEventListener('change', this.onCartChange.bind(this));

    document.addEventListener('cart:updated', () => this.initialize());

    this.initialize();
  }

  initialize() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        this.cart = cart;
        this.calculateProgress(cart);
      })
      .catch(error => {
        console.error('Error fetching cart:', error);
      });
  }

  onCartChange(e) {
    this.initialize();
  }

  calculateProgress(cart) {
    // próg liczony przy każdym przeliczeniu — kraj z geolokalizacji może
    // pojawić się później niż pierwszy render (consent → detekcja → cache)
    const threshold = FreeShippingComponent.resolveThreshold();
    if (threshold.hidden) {
      this.style.display = 'none';
      return;
    }
    this.style.display = '';
    this.thresholdPrice = FreeShippingComponent.convertToActive(threshold.amount, threshold.currency);

    let totalPrice = cart.total_price;

    if (document.body.classList.contains('setup_shipping_delivery')) {
      const giftCardItems = document.querySelectorAll(".cart-item[data-price-gift-card], .previewCartItem[data-price-gift-card]");
      if (giftCardItems.length > 0) {
        giftCardItems.forEach(item => {
          totalPrice -= parseFloat(item.getAttribute("data-price-gift-card"));
        });
      }
    }

    const cartTotalPrice = parseInt(totalPrice) / 100;
    const cartTotalPriceFormatted = cartTotalPrice;
    const cartTotalPriceRounded = parseFloat(cartTotalPriceFormatted);

    let freeShipBar = Math.abs((cartTotalPriceRounded * 100) / this.thresholdPrice);
    if (freeShipBar >= 100) {
      freeShipBar = 100;
    }

    const text = this.getText(cartTotalPriceFormatted, freeShipBar);
    const classLabel = this.getClassLabel(freeShipBar);

    this.setProgressWidthAndText(freeShipBar, text, classLabel);
  }

  getText(cartTotalPrice, freeShipBar) {
    let text;

    if (cartTotalPrice >= this.thresholdPrice) {
      this.progressBar.classList.remove('progress-hidden');
      this.freeShippingEligible = 1;
      text = FreeShippingComponent.freeShippingText1;
    } else {
      // Pusty koszyk (total 0) też tu wpada: komunikat „ile brakuje" + widoczny pasek na 0%
      this.progressBar.classList.remove('progress-hidden');
      const remainingPrice = Math.abs(this.thresholdPrice - cartTotalPrice);
      text = '<span>' + FreeShippingComponent.freeShippingText2 + ' </span>' + Shopify.formatMoney(remainingPrice.toFixed(2) * 100, window.money_format) + '<span> ' + FreeShippingComponent.freeShippingText3 + ' </span><span class="text">' + FreeShippingComponent.freeShippingText4 + '</span>';
      this.shipVal = window.free_shipping_text.free_shipping_2;
    }

    return text;
  }

  getClassLabel(freeShipBar) {
    let classLabel;

    if (freeShipBar === 0) {
      // pusty koszyk: track ma zostać widoczny (meter i tak 0% szer.) — NIE 'none'
      // ('none' to globalny util display:none, który chował cały pasek)
      classLabel = 'progress-30';
    } else if (freeShipBar <= 30) {
      classLabel = FreeShippingComponent.classLabel1;
    } else if (freeShipBar <= 60) {
      classLabel = FreeShippingComponent.classLabel2;
    } else if (freeShipBar < 100) {
      classLabel = FreeShippingComponent.classLabel3;
    } else {
      classLabel = 'progress-free';
    }

    return classLabel;
  }

  resetProgressClass(classLabel) {
    this.progressBar.classList.remove('progress-30');
    this.progressBar.classList.remove('progress-60');
    this.progressBar.classList.remove('progress-100');
    this.progressBar.classList.remove('progress-free');

    this.progressBar.classList.add(classLabel);
  }

  setProgressWidthAndText(freeShipBar, text, classLabel) {
    setTimeout(() => {
      this.resetProgressClass(classLabel);

      this.progressMeter.style.width = `${freeShipBar}%`;

      if (this.textEnabled) {
        const textWrapper = this.progressMeter.querySelector('.text');
        textWrapper.innerHTML = `${freeShipBar.toFixed(2)}%`;
      }

      // etykieta progu renderowana serwerowo — odśwież, gdy geolokalizacja
      // wskaże inny kraj (inny próg) niż kraj sesji z SSR
      const thresholdLabel = this.querySelector('.free-shipping-bar__threshold b');
      if (thresholdLabel && this.thresholdPrice > 0 && window.Shopify && typeof Shopify.formatMoney === 'function') {
        thresholdLabel.innerHTML = Shopify.formatMoney((this.thresholdPrice * 100).toFixed(0), window.money_format);
      }

      this.messageElement.innerHTML = text;
    }, 400);
  }

}

window.addEventListener('load', () => {
  customElements.define('free-shipping-component', FreeShippingComponent);
});